import { useApi } from '@/hooks/useApi'
import { BasicPage } from '@/components/layout/BasicPage'
import { Button } from '@/components/action/Button'
import { PUBLIC_WEBSITE } from '@/utilities/envVariables'
import { routes } from '@/utilities/routes'
import { tenantListMineSpec, UserRole, type TenantRow } from 'aevocam-rest-api-spec'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Notice } from '@/components/action/Notice'
import { toastWarning } from '@/components/action/Toaster'
import { Spinner } from '@/components/graphics/Spinner'
import { HomeLaunchInvitations } from './HomeLaunchInvitations'

//TODO: User needs to be able to change their basic settings (name, email)

export function HomeLaunchPage() {

  const api = useApi({
    requireLogin: true,
  })

  const [loading, setLoading] = useState(true)
  const [tenants, setTenants] = useState<TenantRow[]>([])

  const hasTenants = tenants.length > 0

  useEffect(() => {
    setLoading(true)
    api.request(tenantListMineSpec).then(res => {
      const tenants = res.data?.tenants ?? []
      setTenants(tenants)
      setLoading(false)
    })
  }, [])

  //--------------------------------------------------------------------------------
  // Render
  return (
    <BasicPage
      title='Home'
      toolbarButtons={loading ? undefined : (<>
        <Button
          label='Aevocam home'
          icon='home'
          href={PUBLIC_WEBSITE}
        />
        <Button
          label='New tenant'
          icon='plus'
          href={routes.tenantEdit('new')}
        />
        <Button
          label='Log out'
          icon='lock'
          href={routes.logOut()}
        />
      </>)}
    >

      {loading
        //TODO: Add loading thingy to <BasicPage>
        ? (
          <div className='Cutout Wrapped'>
            <Spinner /> Loading
          </div>
        )
        : (
          <>

            <div className='FlexBricks'>

              {hasTenants
                ? (
                  <div className='Cutout Wrapped' style={{ maxWidth: '25rem'}}>
                    <h2>My tenancies</h2>
                    <ul>
                      {tenants
                        .map(tenant => tenant.id && (
                          <li key={tenant.id}>
                            <Link to={routes.home(tenant.id.toString())}>{tenant.name}</Link>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                )
                : (
                  <div className='Cutout FlexColumn Gap4' style={{ maxWidth: '30rem'}}>
                    <h2>No Aevocam tenants</h2>

                    <Notice variant='info' className='Unaligned'>
                      <p>
                        Welcome {api.status.session?.userName}!
                      </p>
                      <p>
                        Your user account is not currently associated with any Aevocam
                        tenants. If you are new you can create your own tenant. Or
                        you can give your email address to your organization's
                        administration to get your email address added to their 
                        Aevocam account.
                      </p>
                    </Notice>

                    <div>
                      <Button
                        variant='primary'
                        label='Register a new tenant'
                        icon='plus'
                        href={routes.tenantEdit('new')}
                      />
                    </div>

                  </div>
                )
              }

              <HomeLaunchInvitations />

            </div>

          </>
        )
      }

    </BasicPage>
  )
}
